import { z } from "zod";
import type { Env as QueryEnv } from "@mozioinc/query";

const envSchema = z.object({
  VERCEL_ENV: z.enum(["production", "development", "preview"]),
  VERCEL_GIT_COMMIT_SHA: z.string(),
  VERCEL_GIT_PREVIOUS_SHA: z.string(),
  VERCEL_BRANCH_URL: z.string(),
  VERCEL_URL: z.string(),
  DEV: z.boolean(),
  PROD: z.boolean(),
  MOZIO_PUBLIC_STRIPE_API_KEY: z.string(),
  MOZIO_PUBLIC_SENTRY_DSN: z.string().optional(),
  MOZIO_PUBLIC_LOGGLY_TOKEN: z.string().optional(),
  MOZIO_PUBLIC_POSTHOG_KEY: z.string(),
  MOZIO_PUBLIC_POSTHOG_HOST: z.string(),
  MOZIO_PUBLIC_SENTRY_ORGANIZATION: z.string(),
  MOZIO_PUBLIC_SENTRY_PROJECT_ID: z.coerce.number(),
});

type Envs = z.infer<typeof envSchema> & {
  QUERY_ENV: QueryEnv;
  ASSET_BASE_URL: string;
};

let envMemo: Envs;

export const getEnvs = (): Envs => {
  if (envMemo) return envMemo;
  const envs = envSchema.parse(import.meta.env);

  envMemo = {
    ...envs,
    QUERY_ENV: envs.VERCEL_ENV === "production" ? "production" : "staging",
    ASSET_BASE_URL: envs.PROD
      ? `https://${envs.VERCEL_URL}/parking`
      : "/parking",
  };

  return envMemo;
};
